import React from "react";

export default function Footer({ maxWidth }) {
  return (
    <footer
      className={`flex h-full w-full justify-center items-end text-xs text-gray-500 mt-2 mb-4 px-6 sm:px-0 ${
        maxWidth ? maxWidth : "max-w-2xl lg:max-w-3xl"
      }`}>
      <div className="flex flex-wrap justify-center w-full md:justify-between">
        <div className="flex whitespace-no-wrap items-center">
          <span>Hotel Engine &copy; {new Date().getFullYear()}. Made with</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="mx-1">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
          </svg>{" "}
          <span>in Denver, CO</span>
        </div>
        <div className="flex">
          <a
            className="mr-2 hover:text-blue-500 hover:underline"
            href="https://www.hotelengine.com/terms-of-service/"
            target="__blank">
            Terms of Service
          </a>
          <a
            className="hover:text-blue-500 hover:underline"
            href="https://www.hotelengine.com/privacy-policy/"
            target="__blank">
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  );
}
